module.exports = __webpack_public_path__ + "img/CU.5b868340.svg";